import axios from "./axios";

export default {
    createApiKey( ID_Branch, ID_User ) {
        const options = {
            method: "POST",
            url: "/auth/apikey",
            data: {
                ID_Branch,
                ID_User
            }
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    getApiKeys() {
        const options = {
            method: "GET",
            url: "/auth/apikeys",
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    deactivateApiKey(idApiKey) {
        const options = {
            method: "POST",
            url: "/auth/apikey/deactivate",
            data: {
                id_api_key: idApiKey,
            },
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};
